import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const token = localStorage.getItem("token"); // Get the stored token

  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
